/*eslint-disable*/
import LangToggle from "components/Toggles/LangToggle.js";

export default function Navbar() {
  return (
    <>
      <nav
        className={`top-0 z-10 w-full flex flex-wrap items-center justify-between px-2 py-3 bg-transparent h-80-px`}
      >
        <div className="px-4 mx-auto flex items-center justify-between w-full">
          <div className="w-full block justify-start">
            <a
              href="https://foundation.ainft.com/"
              className="leading-relaxed inline-block mr-4 whitespace-nowrap"
            >
              <img src={require("assets/img/logo_new.svg").default} width="120" />
            </a>
            {/* <button
              className="cursor-pointer text-xl leading-none px-3 py-1 border border-solid border-transparent rounded bg-transparent block hidden outline-none focus:outline-none"
              type="button"
              onClick={() => setNavbarOpen(!navbarOpen)}
            >
              <i className="fas fa-bars"></i>
            </button> */}
          </div>
          <div
            className="flex flex-grow items-center bg-opacity-0 shadow-none br-16-px py-4"
            id="example-navbar-warning"
          >
            <ul className="flex flex-row list-none ml-auto">
              <li className="flex items-center">
                <div className="ml-4">
                  <LangToggle />
                </div>
              </li>
            </ul>
          </div>
        </div>
      </nav>
    </>
  );
}
